import { render, staticRenderFns } from "./PicksProgressBar.vue?vue&type=template&id=70889990&"
import script from "./PicksProgressBar.vue?vue&type=script&lang=js&"
export * from "./PicksProgressBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports